// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"266":"css/style","291":"css/lp","615":"css/pdf"}[chunkId] + ".css";
};